module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "planning-conge-container",
    attrs: {
      "data-testid": "planningContainer-planning-section"
    }
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "head-left"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Planning des absences")]), _vm._v(" "), (_vm.canShow && _vm.showTabV3) ? [(_vm.showAutresSalariesTabV3) ? _c('el-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "data-testid": "planning-section-tab-mon-planning",
      "label": "Mon planning",
      "name": "MonPlanning"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "data-testid": "planning-section-tab-autres-salaries",
      "label": "Autres salariés",
      "name": "AutreSalaries"
    }
  })], 1) : _vm._e()] : (_vm.canShow && _vm.showTabV4) ? [(_vm.showAutresSalariesTabV4 || _vm.showAllSalariesTabV4) ? _c('el-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "data-testid": "planning-section-tab-mon-planning",
      "label": "Mon planning",
      "name": "MonPlanning"
    }
  }), _vm._v(" "), (_vm.showAutresSalariesTabV4) ? _c('el-tab-pane', {
    attrs: {
      "data-testid": "planning-section-tab-autres-salaries",
      "label": "Mon équipe / Mon service",
      "name": "AutreSalaries"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAllSalariesTabV4) ? _c('el-tab-pane', {
    attrs: {
      "data-testid": "planning-section-tab-tous-salaries",
      "label": "Tous les salariés",
      "name": "TousSalaries"
    }
  }) : _vm._e()], 1) : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "head-right"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "data-testid": "planning-section-openModalAbsence-button",
      "icon": "ri-add-line",
      "size": "small"
    },
    on: {
      "click": _vm.openModalAbsence
    }
  }, [_vm._v("\n                Ajouter une demande d’absence\n            ")])], 1)]), _vm._v(" "), (_vm.showTabV3 && !_vm.showTabV4) ? [(_vm.calendrier && _vm.activeTab === 'MonPlanning') ? _c(_vm.calendrier, {
    tag: "component",
    attrs: {
      "type-calendrier": _vm.TypeCalendrier.EspaceSalarie
    }
  }) : (_vm.activeTab === 'AutreSalaries') ? _c('div', {
    staticClass: "calendrier-autres-salaries"
  }, [_c('calendrier-v1', {
    attrs: {
      "type-calendrier": _vm.TypeCalendrier.EspaceValideurSalarie
    }
  })], 1) : _vm._e()] : [(_vm.calendrier && _vm.activeTab === 'MonPlanning') ? _c(_vm.calendrier, {
    tag: "component",
    attrs: {
      "type-calendrier": _vm.TypeCalendrier.EspaceSalarie
    }
  }) : (_vm.activeTab === 'AutreSalaries' || _vm.activeTab === 'TousSalaries') ? _c('div', {
    staticClass: "calendrier-autres-salaries"
  }, [_c('calendrier-equipe', {
    attrs: {
      "active-tab": _vm.activeTab
    }
  })], 1) : _vm._e()], _vm._v(" "), (_vm.modalAbsenceVisible) ? _c('modal-ajout-conge', {
    attrs: {
      "exercice": _vm.exercice,
      "absenceToModifyId": _vm.absenceToModifyId
    },
    on: {
      "closeModal": _vm.closeModalAbsence
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f075850"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsencesV2/planningConge/planningConge.vue.html
// module id = AtmI
// module chunks = 2